"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroupOption = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RadioGroupOption, _Component);

  function RadioGroupOption() {
    (0, _classCallCheck3.default)(this, RadioGroupOption);
    return (0, _possibleConstructorReturn3.default)(this, (RadioGroupOption.__proto__ || (0, _getPrototypeOf2.default)(RadioGroupOption)).apply(this, arguments));
  }

  (0, _createClass3.default)(RadioGroupOption, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          option = _props.option,
          name = _props.name,
          fieldProps = _props.fieldProps;


      return _react2.default.createElement("input", {
        id: option.id,
        type: "radio",
        name: name,
        value: option.value,
        onChange: fieldProps.onChange,
        checked: fieldProps.value === option.value
      });
    }
  }]);
  return RadioGroupOption;
}(_react.Component), _class.propTypes = {
  option: _react.PropTypes.object.isRequired,
  name: _react.PropTypes.string.isRequired,
  fieldProps: _react.PropTypes.object.isRequired
}, _temp);
exports.default = RadioGroupOption;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/RadioGroupOption.js
 ** module id = 479
 ** module chunks = 0
 **/